import { render, staticRenderFns } from "./threeTextParams.vue?vue&type=template&id=ff28954a&scoped=true"
import script from "./threeTextParams.vue?vue&type=script&lang=js"
export * from "./threeTextParams.vue?vue&type=script&lang=js"
import style0 from "./threeTextParams.vue?vue&type=style&index=0&id=ff28954a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff28954a",
  null
  
)

export default component.exports